// extracted by mini-css-extract-plugin
export default {"darkSection":"darkSection__z1lkm","separator":"separator__4BOkH","button":"button__W1eZk","text":"text__4-2vn"};